import { NgModule, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './modules/core/core.module';
import { SharedModule } from './modules/shared/shared.module';

import { APP_INITIALIZER } from '@angular/core';
import { AppConfig } from './services/app.config.services';
import { HttpClientModule } from '@angular/common/http';
import { TrsEventsService } from './services/trsevents.service';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxIdleTimeoutModule } from 'ngx-idle-timeout';
import { wsService } from './services/ws.service';
import { log } from './utils/logging';
import { AgentListInfo } from './services/agent.list.info';
import { AuditService } from './services/audit.service';
import { TreeviewModule } from 'ngx-treeview';

const packageInfo = require('../../package.json');

import * as $ from 'jquery';
import { TranslocoRootModule } from './transloco-root.module';
import { FaceLoginService } from './services/face-login.service';
import { WebRTCService } from './services/webrtc.service';
import { TeamCheckInService } from './services/team.checkin.service';
import { EventFilterService } from './services/event-filter.service';
import { SupervisorService } from './services/supervisor.service';

export function initializeApp(appConfig: AppConfig) {
  //load app configs
  console.info(`SWFH Supervisor UI v${packageInfo.version}`);
  return () => appConfig.load().then(() => loadLogConfigs()).catch((error: any) => { });
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    CoreModule,
    NgxIdleTimeoutModule,
    HttpClientModule,
    ToastrModule.forRoot(),
    BrowserAnimationsModule,
    TranslocoRootModule,
    TreeviewModule.forRoot(),
  ],
  providers: [TrsEventsService, wsService, AppConfig, AgentListInfo,
    AuditService, FaceLoginService, WebRTCService, TeamCheckInService,
    EventFilterService, SupervisorService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppConfig], multi: true
    }
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  bootstrap: [AppComponent]
})

export class AppModule {
}

const loadLogConfigs = (): void => {
  if (AppConfig.settings.UILogUpload.Enabled === true) {
    window.uiLoggerConfigs = {
      uiLoggerServerUrls: AppConfig.settings.UILogUpload.ServerURL,
      applicationName: "SWFH_Supervisor"
    };

    const script: HTMLScriptElement = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'assets/scripts/ui-logger-sdk.js';
    log.debug(`Load Log sdk file: ${script.src}`);
    document.body.appendChild(script);
  }
}
